import { useAppSelector } from "@3gaam/app/src/store/hooks";
import { VersionManagerModal } from "@3gaam/app/src/versionManagerModal";
import "@3gaam/shared/assets/scss/style.scss";
import PageLoader from "@3gaam/shared/components/general/pageLoader";
import { Suspense, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import routes from "./routes/main";

import { BackgroundHooks } from "@3gaam/app/src/hooks/backgroundHooks";
import { isConsultant as checkConsultant } from "@3gaam/app/src/utils/hasPermission";
import Notification from "@3gaam/app/src/view/components/general/notification";
import initializeApp from "@3gaam/app/src/view/components/hoc/initializeApp";
import CounselorAvatar from "@3gaam/shared/components/counselor/counselorAvatar";
import Settings from "@3gaam/shared/pcapp/components/package/Settings";

import { ReactNotifications } from "@3gaam/shared/components/general/notification";
import {
  MinimalToast,
  Provider as PopoverProvider,
} from "@3gaam/shared/components/general/popover";
import { Portal } from "@3gaam/shared/components/general/Portal";
import { Redirect } from "@3gaam/shared/components/general/redirect";
import RatingModal from "@3gaam/shared/pcapp/components/rate/RatingModal";
import { useDynamicComponents } from "@3gaam/shared/pcapp/useDynamicComponents";
import { useRatingComponent } from "@3gaam/shared/pcapp/useRatingComponent";
import { redirectToLogin } from "@3gaam/shared/utils/redirectToLogin";
import { Rating } from "react-simple-star-rating";
import { install } from "resize-observer";

const RedirectToLogin = () => {
  const loggedOutManually = useAppSelector((state) => state.auth.loggedOut);
  useEffect(() => {
    if (loggedOutManually) {
      redirectToLogin();
    } else {
      redirectToLogin(true);
    }
  }, [loggedOutManually]);

  return <PageLoader text={"در حال انتقال"} />;
};

const App = () => {
  install();
  const isLoggedIn = useAppSelector((state) => state.auth.isLoggedIn);

  let [isConsultant, setIsConsultant] = useState(false);
  useEffect(() => {
    setIsConsultant(checkConsultant());
  }, [isConsultant]);

  let { initiateRating } = useRatingComponent();
  let { initiateComponents } = useDynamicComponents();

  useEffect(() => {
    initiateRating(Rating);
  }, [initiateRating]);

  useEffect(() => {
    initiateComponents({ CounselorAvatar, Settings });
  }, [initiateComponents]);

  return (
    <>
      <PopoverProvider>
        <Router>
          <Routes>
            {routes.map((route, i) => {
              if (route.loginRequired && !isLoggedIn) {
                return (
                  <Route
                    path={route.path}
                    key={route.path + i}
                    element={<RedirectToLogin />}
                  />
                );
              } else if (route.redirect) {
                return (
                  <Route
                    path={route.path}
                    element={<Redirect route={route} />}
                    key={route.path + i}
                  />
                );
              } else {
                return (
                  <Route
                    path={route.path}
                    element={
                      <Suspense fallback={<PageLoader />}>
                        {route.layout ? (
                          <route.layout>
                            <Helmet>
                              <title>{`${route.title} - ${process.env.REACT_APP_WEBSITE_TITLE}`}</title>
                            </Helmet>
                            <route.component {...route} />
                          </route.layout>
                        ) : (
                          <>
                            <Helmet>
                              <title>{`${route.title} - ${process.env.REACT_APP_WEBSITE_TITLE}`}</title>
                            </Helmet>
                            <route.component {...route} />
                          </>
                        )}
                      </Suspense>
                    }
                    key={route.path + i}
                  >
                    {route.subRoutes
                      ? route.subRoutes.map((subRoute, index) => {
                          if (
                            isConsultant &&
                            subRoute.consultantPermissionDenied
                          )
                            return null;
                          return (
                            <Route
                              path={subRoute.path}
                              element={
                                <>
                                  <subRoute.component {...subRoute} />
                                </>
                              }
                              key={subRoute.title + index}
                            />
                          );
                        })
                      : null}
                  </Route>
                );
              }
            })}
          </Routes>
          <MinimalToast />
          <Notification />
          <ReactNotifications />
          <BackgroundHooks />
          <RatingModal />
        </Router>
      </PopoverProvider>

      <VersionManagerModal />
      <Portal />
    </>
  );
};

export default initializeApp(App);
